const baseStyle = () => {
  return {
    borderColor: 'white',
    _input: {
      background: 'white',
      borderColor: 'white',
    },
    _stack: {
      shadow: 0,
      borderColor: 'white',
      _hover: {
        background: 'white',
      },
    },
    _left: {
      alignItems: 'center',
      bgColor: 'white',
      height: '100%',
      justifyContent: 'center',
      paddingLeft: 2.5,
      py: 2,
    },
    _right: {
      alignItems: 'center',
      bgColor: 'white',
      height: '100%',
      justifyContent: 'center',
      paddingLeft: 2.5,
      py: 2,
    },
  };
};

export default { baseStyle };
